import type { AccommodationDayCellVariant } from 'components/AccommodationKit/AccommodationCalendar/AccommodationCalendarLargeDayCell'

export function getAlternativeDateOccupancyRooms(rooms: Array<App.Occupants>): Array<App.Occupants> {
  return rooms.map(({ adults, children, infants, childrenAge }) => ({
    adults,
    children,
    infants,
    childrenAge,
  }))
}

export function buildAvailabilityVariantMap(
  availabilityData: Record<string, boolean> | undefined,
): Map<string, AccommodationDayCellVariant> | undefined {
  if (!availabilityData) return undefined

  return new Map(
    Object.entries(availabilityData)
      .sort(([leftDate], [rightDate]) => leftDate.localeCompare(rightDate))
      .map(([date, isAvailable]): [string, AccommodationDayCellVariant] => [
        date,
        isAvailable ? 'availability-available' : 'availability-search',
      ]),
  )
}
